"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubsPairMgr = void 0;
const RefWrapper_1 = require("./RefWrapper");
class SubsPairMgr {
    constructor(type, send, getKey = (item) => {
        return Object.values(item).sort().join("/");
    }) {
        this.subscribeTickerPair = new Map();
        this.type = type;
        this.send = send;
        this.getKey = getKey;
    }
    getSubData(subscribeTickerPair) {
        // 交易所列表
        const exchanges = [];
        // 交易对列表，如果对应的交易所已经按交易所订阅，这里就不需要单独订阅币对了
        const pairs = [];
        const refWrappers = Array.from(subscribeTickerPair.values()).sort();
        refWrappers.forEach(({ value: originValue }) => {
            const value = originValue;
            // 处理交易所列表
            if (!value.base && !value.quote && !exchanges.includes(value.market)) {
                exchanges.push(value.market);
            }
            // 处理交易对列表
            if (exchanges.includes(value.market)) {
                return;
            }
            const { market } = value, deleteMarketValue = __rest(value, ["market"]);
            const ele = Object.assign({ exchange: value.market }, deleteMarketValue);
            pairs.push(ele);
        });
        const data = [];
        if (exchanges.length > 0) {
            data.push(...exchanges.map((exchange) => ({ exchange })));
        }
        if (pairs.length > 0) {
            data.push(...pairs);
        }
        return data;
    }
    haveChanged(oldData, newData) {
        if (oldData.length !== newData.length) {
            return true;
        }
        return newData.some((item, index) => {
            // 寻找不一样的那个
            const newKey = this.getKey(item);
            const oldKey = this.getKey(oldData[index]);
            return newKey !== oldKey;
        });
    }
    reSubscribe(data) {
        if (!this.type || !this.send) {
            return;
        }
        this.send(this.type, data, this.subscribeTickerPair);
    }
    justReSubscribe() {
        this.reSubscribe(this.getSubData(this.subscribeTickerPair));
    }
    addSubscribePair(param) {
        const oldData = this.getSubData(this.subscribeTickerPair);
        param.forEach((item) => {
            const key = this.getKey(item);
            const refValue = this.subscribeTickerPair.get(key);
            if (refValue) {
                refValue.add();
            }
            else {
                this.subscribeTickerPair.set(key, new RefWrapper_1.RefWrapper(item));
            }
        });
        const newData = this.getSubData(this.subscribeTickerPair);
        if (this.haveChanged(oldData, newData)) {
            this.reSubscribe(newData);
        }
    }
    removeSubscribePair(param) {
        const oldData = this.getSubData(this.subscribeTickerPair);
        const deleted = [];
        param.forEach((item) => {
            let refValue;
            const key = this.getKey(item);
            refValue = this.subscribeTickerPair.get(key);
            if (refValue) {
                refValue.delete();
                if (refValue.count <= 0) {
                    deleted.push(item);
                    this.subscribeTickerPair.delete(key);
                }
            }
        });
        const newData = this.getSubData(this.subscribeTickerPair);
        if (this.haveChanged(oldData, newData)) {
            this.reSubscribe(newData);
        }
        return deleted;
    }
    getSubscribePair() {
        return this.getSubData(this.subscribeTickerPair);
    }
}
exports.SubsPairMgr = SubsPairMgr;
